import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstanse";

interface AddressBookRequest {
    searchText: string;
}

export interface AddressItem {
    idx: number;
    a_code: string | null;
    a_company: string;
    a_tel: string;
    a_name: string | null;
    a_mobile: string | null;
    a_post: string;
    a_address: string;
    a_address_detail: string | null;
}

interface AddressBookResponse {
    statusCode: number;
    message: string;
    data: AddressItem[];
}

export const usePostAddressBook = (
    successCallback?: (data: AddressItem[]) => void,
): UseMutationResult<AddressBookResponse, Error, AddressBookRequest, unknown> => {
    return useMutation<AddressBookResponse, Error, AddressBookRequest>({
        mutationFn: async ({ searchText }) => {
            const response = await axiosInstance.post(enum_api_uri.address, {
                searchText,
            });
            return response.data;
        },
        onSuccess: data => {
            successCallback?.(data.data);
        },
    });
};
